export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/resourceManage',
    component: '#',
    name: 'resourceManage',
    redirect: '/resourceManage/menu',
    meta: {
      title: '资源管理',
      icon: 'vi-ep:menu',
      alwaysShow: true,
    },
    children: [
      {
        path: 'menu',
        name: 'resourceMenu',
        component: 'views/ResourceManage/Menu/index',
        meta: {
          title: '菜单管理',
        },
      },
    ],
  },
  {
    path: '/hospitalManage',
    component: '#',
    name: 'hospitalManage',
    redirect: '/hospitalManage/hospitalList',
    meta: {
      title: '医院管理',
      icon: 'vi-ep:management',
      alwaysShow: true,
    },
    children: [
      {
        path: 'hospitalList',
        name: 'hospitalList',
        component: 'views/HospitalManage/HospitalList/index',
        meta: {
          title: '医院列表',
        },
        children: [
          {
            path: 'hospitalDetail',
            name: 'hospitalDetail',
            component: 'views/HospitalManage/HospitalList/Detail/index',
            meta: {
              title: '医院详情',
              hidden: true,
              subPageKey: '/hospitalManage/hospitalList/hospitalDetail', // 菜单列表页， 需要跳转的详情，新增，编辑子页面唯一标识,对应后台资源配置按钮和其它，的唯一标识字段（用于补齐未在菜单展示的详情/新增/编辑页路由）
            },
          },
        ],
      },
    ],
  },
  {
    path: '/preConfigManage',
    component: '#',
    name: 'preConfigManage',
    redirect: '/preConfigManage/productList',
    meta: {
      title: '预配置管理',
      icon: 'vi-ep:setting',
      alwaysShow: true,
    },
    children: [
      {
        path: 'productList',
        name: 'productList',
        component: 'views/PreConfigManage/ProductList/index',
        meta: {
          title: '产品列表',
        },
        children: [
          // 新增和编辑共用一个页面
          {
            path: 'addProduct',
            name: 'addProduct',
            component: 'views/PreConfigManage/ProductList/AddProduct/index',
            meta: {
              title: '新增产品',
              hidden: true,
              subPageKey: '/preConfigManage/productList/addProduct',
            },
          },
          // 产品导入页面
          {
            path: 'productImportPage',
            name: 'productImportPage',
            component: 'views/Setting/ImportManage/BatchImport/index',
            meta: {
              title: '产品导入',
              hidden: true,
              subPageKey: '/setting/ImportManage/productBatchImport',
            },
          },
        ],
      },
      {
        path: 'brandManage',
        name: 'brandManage',
        component: 'views/PreConfigManage/BrandManage/index',
        meta: {
          title: '品牌管理',
        },
      },
      {
        path: 'lisCheckItems',
        name: 'lisCheckItems',
        component: 'views/PreConfigManage/LisCheckItems/index',
        meta: {
          title: 'LIS检验项目',
        },
      },
      // 医疗文书
      {
        path: 'medicalDocument',
        name: 'medicalDocument',
        component: 'views/PreConfigManage/MedicalDocument/index',
        meta: {
          title: '医疗文书',
        },
        children: [
          // 新增和编辑共用一个页面
          {
            path: 'addMedicalDocument',
            name: 'addMedicalDocument',
            component: 'views/PreConfigManage/MedicalDocument/AddPage/index',
            meta: {
              title: '新增医疗文书',
              hidden: true,
              subPageKey: '/preConfigManage/medicalDocument/addMedicalDocument',
            },
          },
          {
            path: 'editMedicalDocument',
            name: 'editMedicalDocument',
            component: 'views/PreConfigManage/MedicalDocument/AddPage/index',
            meta: {
              title: '编辑医疗文书',
              hidden: true,
              subPageKey: '/preConfigManage/medicalDocument/editMedicalDocument',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/importTaskListManage',
    component: '#',
    name: 'importTaskListManage',
    redirect: '/importTaskList/index',
    meta: {
      title: '导入管理',
    },
    children: [
      {
        path: 'importTaskList',
        name: 'importTaskList',
        component: 'views/ImportTaskList/index',
        meta: {
          title: '导入列表',
          icon: 'vi-ep:upload',
          subPageKey: '/importTaskListManage/importTaskList',
        },
      },
    ],
  },
  {
    path: '/contentManage',
    component: '#',
    name: 'contentManage',
    redirect: '/contentManage/informationKnowledge',
    meta: {
      title: '内容管理',
      icon: 'vi-ep:folder',
      alwaysShow: true,
    },
    children: [
      {
        path: 'informationKnowledge',
        name: 'informationKnowledge',
        component: 'views/ContentManage/InformationKnowledge/index',
        meta: {
          title: '资讯与知识',
        },
        children: [
          {
            path: 'detail',
            name: 'informationKnowledgeDetail',
            component: 'views/ContentManage/InformationKnowledge/Detail/index',
            meta: {
              title: '资讯与知识详情',
              hidden: true,
              subPageKey: '/contentManage/informationKnowledge/detail',
            },
          },
        ],
      },
      {
        path: 'productUpdate',
        name: 'productUpdate',
        component: 'views/ContentManage/ProductUpdate/index',
        meta: {
          title: '产品更新',
        },
        children: [
          {
            path: 'detail',
            name: 'productUpdateDetail',
            component: 'views/ContentManage/ProductUpdate/Detail/index',
            meta: {
              title: '产品更新详情',
              hidden: true,
              subPageKey: '/contentManage/productUpdate/detail',
            },
          },
        ],
      },
      {
        path: 'operationGuide',
        name: 'operationGuide',
        component: 'views/ContentManage/OperationGuide/index',
        meta: {
          title: '操作指引',
        },
      },
    ],
  },
];
